export const seoPageTitle = "Swap & Bridge Assets | AlphaMind";
export const seoPageDescription =
  "Instantly bridge and swap crypto assets across 30+ blockchains with low fees. Secure cross-chain swaps without leaving AlphaMind platform.";
export const seoUrl = "https://app.alphamind.co/bridge";
export const seoKeyWords =
  "crypto, bridge, swap, blockchain, cross-chain, AlphaMind";
